module.exports = __webpack_public_path__ + "img/m-switch-version.6fa67e4b.png";